import { ReactNode } from "react";
import { Group, Stack, Text, Title } from "@mantine/core";

export interface ReportSectionProps {
    title: string;
    meta?: ReactNode;
    children: ReactNode;
}

// Flat, card-driven section header: a title with an optional right-aligned meta.
// No divider — sections are separated by whitespace (the parent Stack's spacing).
export const ReportSection = ({ title, meta, children }: ReportSectionProps) => (
    <Stack spacing="sm">
        <Group position="apart" align="baseline" noWrap>
            <Title order={4} sx={{ color: "#0F1B3D", fontWeight: 700 }}>
                {title}
            </Title>
            {meta && (
                <Text size="sm" color="dimmed" style={{ whiteSpace: "nowrap" }}>
                    {meta}
                </Text>
            )}
        </Group>
        {children}
    </Stack>
);
